'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
export function useBrowserLocale() {
  const $ = _c(2);
  const [browserLocale, setBrowserLocale] = useState("");
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setBrowserLocale(navigator.language);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return browserLocale;
}